import { render, staticRenderFns } from "./relationship.vue?vue&type=template&id=4594f7cc&scoped=true"
import script from "./relationship.vue?vue&type=script&lang=js"
export * from "./relationship.vue?vue&type=script&lang=js"
import style0 from "./relationship.vue?vue&type=style&index=0&id=4594f7cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4594f7cc",
  null
  
)

export default component.exports